/* GENERATED FILE */
import type { ReactElement, FC } from 'react';
import { Path } from 'react-native-svg';
import { type IconWeight } from '../lib';

export default new Map<
  IconWeight,
  ReactElement | FC<{ duotoneColor?: string; duotoneOpacity?: number }>
>([
  [
    'bold',
    <>
      <Path d="M240 52H16A12 12 0 0 0 4 64v128a12 12 0 0 0 12 12h224a12 12 0 0 0 12-12V64a12 12 0 0 0-12-12m-58.79 128H74.79A60.18 60.18 0 0 0 28 133.21v-10.42A60.18 60.18 0 0 0 74.79 76h106.42A60.18 60.18 0 0 0 228 122.79v10.42A60.18 60.18 0 0 0 181.21 180M228 97.94A36.23 36.23 0 0 1 206.06 76H228ZM49.94 76A36.23 36.23 0 0 1 28 97.94V76ZM28 158.06A36.23 36.23 0 0 1 49.94 180H28ZM206.06 180A36.23 36.23 0 0 1 228 158.06V180ZM128 88a40 40 0 1 0 40 40 40 40 0 0 0-40-40m0 56a16 16 0 1 1 16-16 16 16 0 0 1-16 16" />
    </>,
  ],
  [
    'duotone',
    ({
      duotoneColor,
      duotoneOpacity,
    }: {
      duotoneColor?: string;
      duotoneOpacity?: number;
    }) => (
      <>
        <Path
          d="M160 128a32 32 0 1 1-32-32 32 32 0 0 1 32 32m40-64a48.85 48.85 0 0 0 40 40V64Zm0 128h40v-40a48.85 48.85 0 0 0-40 40M16 152v40h40a48.85 48.85 0 0 0-40-40m0-48a48.85 48.85 0 0 0 40-40H16Z"
          opacity={duotoneOpacity}
          fill={duotoneColor}
        />
        <Path d="M128 88a40 40 0 1 0 40 40 40 40 0 0 0-40-40m0 64a24 24 0 1 1 24-24 24 24 0 0 1-24 24m112-96H16a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h224a8 8 0 0 0 8-8V64a8 8 0 0 0-8-8M24 72h21.37A40.8 40.8 0 0 1 24 93.37Zm0 112v-21.37A40.8 40.8 0 0 1 45.37 184Zm208 0h-21.37A40.8 40.8 0 0 1 232 162.63Zm0-38.35A56.78 56.78 0 0 0 193.65 184H62.35A56.78 56.78 0 0 0 24 145.65v-35.3A56.78 56.78 0 0 0 62.35 72h131.3A56.78 56.78 0 0 0 232 110.35Zm0-52.28A40.8 40.8 0 0 1 210.63 72H232Z" />
      </>
    ),
  ],
  [
    'fill',
    <>
      <Path d="M168 128a40 40 0 1 1-40-40 40 40 0 0 1 40 40m80-64v128a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V64a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8m-16 46.35A56.78 56.78 0 0 1 193.65 72H62.35A56.78 56.78 0 0 1 24 110.35v35.3A56.78 56.78 0 0 1 62.35 184h131.3A56.78 56.78 0 0 1 232 145.65Z" />
    </>,
  ],
  [
    'light',
    <>
      <Path d="M128 166a38 38 0 1 0-38-38 38 38 0 0 0 38 38m0-64a26 26 0 1 1-26 26 26 26 0 0 1 26-26m112-44H16a6 6 0 0 0-6 6v128a6 6 0 0 0 6 6h224a6 6 0 0 0 6-6V64a6 6 0 0 0-6-6M22 108.82A54.73 54.73 0 0 0 60.82 70h134.36A54.73 54.73 0 0 0 234 108.82v38.36A54.73 54.73 0 0 0 195.18 186H60.82A54.73 54.73 0 0 0 22 147.18Zm212-12.53A42.8 42.8 0 0 1 207.71 70H234ZM48.29 70A42.8 42.8 0 0 1 22 96.29V70ZM22 159.71A42.8 42.8 0 0 1 48.29 186H22ZM207.71 186A42.8 42.8 0 0 1 234 159.71V186Z" />
    </>,
  ],
  [
    'regular',
    <>
      <Path d="M128 88a40 40 0 1 0 40 40 40 40 0 0 0-40-40m0 64a24 24 0 1 1 24-24 24 24 0 0 1-24 24m112-96H16a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h224a8 8 0 0 0 8-8V64a8 8 0 0 0-8-8m-46.35 128H62.35A56.78 56.78 0 0 0 24 145.65v-35.3A56.78 56.78 0 0 0 62.35 72h131.3A56.78 56.78 0 0 0 232 110.35v35.3A56.78 56.78 0 0 0 193.65 184M232 93.37A40.8 40.8 0 0 1 210.63 72H232ZM45.37 72A40.8 40.8 0 0 1 24 93.37V72ZM24 162.63A40.8 40.8 0 0 1 45.37 184H24ZM210.63 184A40.8 40.8 0 0 1 232 162.63V184Z" />
    </>,
  ],
  [
    'thin',
    <>
      <Path d="M128 164a36 36 0 1 0-36-36 36 36 0 0 0 36 36m0-64a28 28 0 1 1-28 28 28 28 0 0 1 28-28m112-40H16a4 4 0 0 0-4 4v128a4 4 0 0 0 4 4h224a4 4 0 0 0 4-4V64a4 4 0 0 0-4-4M20 107.26A52.75 52.75 0 0 0 59.26 68h137.48A52.75 52.75 0 0 0 236 107.26v41.48A52.75 52.75 0 0 0 196.74 188H59.26A52.75 52.75 0 0 0 20 148.74ZM236 99a44.8 44.8 0 0 1-31-31h31ZM51 68a44.8 44.8 0 0 1-31 31V68Zm-31 89a44.8 44.8 0 0 1 31 31H20Zm185 31a44.8 44.8 0 0 1 31-31v31Z" />
    </>,
  ],
]);
